export default {
    userRoleOptions: [
        {
            label: 'User',
            value: 'user'
        },
        {
            label: 'Task Creator',
            value: 'task_creator'
        }
    ],

    taskStatusOptions: [
        {
            label: 'Done',
            value: 'done'
        },
        {
            label: 'In Progress',
            value: 'in_progress'
        },
        {
            label: 'Open',
            value: 'open'
        }
    ],

    notificationOptions: [
        {
            label: 'Nicht Benachrichtigt',
            value: 'false'
        },
        {
            label: 'Benachrichtigt',
            value: 'true'
        }
    ],

    taskStatusTypeConverter(dbEnum) {
        // convert db enumeration into label text for 'data collection' table
        return this.searchInOptionsForConversion(this.taskStatusOptions, dbEnum)
    },

    userRoleTypeConverter(dbEnum) {
        // convert db enumeration into label text for 'data collection' table
        return this.searchInOptionsForConversion(this.userRoleOptions, dbEnum)
    },

    searchInOptionsForConversion(options, dbEnum) {
        for (const opt of options) {
            if (opt.value === dbEnum) {
                return opt.label
            }
        }
        return ''
    }
}
